"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.evencomApiPermissions = void 0;
exports.evencomApiPermissions = [];
